<app-alert-container></app-alert-container>

<div class="row">
  <!-- Tournament Field List -->
  <div class="col-lg-6">
    <div class="ibox">
      <div class="ibox-title">
        <h5>
          <i class="fa fa-users"></i> Tournament Field
          <span class="field-parameters-inline">
            Max = {{ maxFieldSize() }}, A = {{ aBracketSize() }}, B =
            {{ bBracketSize() }}, C = {{ cBracketSize() }}
          </span>
        </h5>
        <div class="ibox-tools">
          <button
            type="button"
            class="btn btn-primary btn-xs"
            (click)="openFieldParametersModal()"
            [disabled]="!canEditParameters()"
          >
            <i class="fa fa-cog"></i> Edit Parameters
          </button>
        </div>
      </div>
      <div class="ibox-content">
        @if (isLoading()) {
        <div class="text-center p-md">
          <i class="fa fa-spinner fa-spin fa-2x"></i>
          <p class="m-t">Loading players...</p>
        </div>
        } @if (!isLoading()) {
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th width="60">
                  <app-sortable-header
                    [column]="'fieldRank'"
                    [sortConfig]="sortConfig()"
                    (sort)="onSort($event)"
                  >
                    Rank
                  </app-sortable-header>
                </th>
                <th width="60">
                  <app-sortable-header
                    [column]="'abrank'"
                    [sortConfig]="sortConfig()"
                    (sort)="onSort($event)"
                  >
                    A Rank
                  </app-sortable-header>
                </th>
                <th width="80">
                  <app-sortable-header
                    [column]="'categoryName'"
                    [sortConfig]="sortConfig()"
                    (sort)="onSort($event)"
                  >
                    Cat
                  </app-sortable-header>
                </th>
                <th width="60">
                  <app-sortable-header
                    [column]="'type'"
                    [sortConfig]="sortConfig()"
                    (sort)="onSort($event)"
                  >
                    Type
                  </app-sortable-header>
                </th>
                <th>
                  <app-sortable-header
                    [column]="'playerLastName'"
                    [sortConfig]="sortConfig()"
                    (sort)="onSort($event)"
                  >
                    Name
                  </app-sortable-header>
                </th>
                <th width="20">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (player of paginationResult().items; track player.playerId) {
              <tr
                (click)="selectFieldPlayer(player.playerId!)"
                (dblclick)="editPlayer(player)"
                style="cursor: pointer"
                [class.table-info]="isFieldPlayerSelected(player.playerId!)"
              >
                <td>{{ player.fieldRank }}</td>
                <td>{{ player.abrank }}</td>
                <td>{{ player.categoryName }}</td>
                <td>{{ player.type }}</td>
                <td>
                  <strong
                    >{{ player.playerLastName }},
                    {{ player.playerFirstName }}</strong
                  >
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-white btn-xs"
                    (click)="editPlayer(player)"
                    title="Edit Player"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-white btn-xs"
                    (click)="deletePlayerFromField(player)"
                    title="Delete Player"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              } @if (paginationResult().totalItems === 0) {
              <tr>
                <td colspan="7" class="text-center text-muted">
                  <em>
                    @if (alternatePlayers().length > 0) { Alternates are
                    available. Use "Edit Parameters" to rank and distribute
                    players into the field. } @else { No players in field. Click
                    "Import Data" to import players. }
                  </em>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <app-table-pagination
          [paginationData]="paginationResult()"
          (pageChange)="onPageChange($event)"
        >
        </app-table-pagination>
        }
      </div>
      <div class="ibox-footer text-right">
        @if (isImporting) {
        <span class="pull-left">
          <i class="fa fa-spinner fa-spin"></i>
          <span class="m-l-sm">{{ importProgress }}</span>
        </span>
        } @if (!isImporting) {
        <button
          type="button"
          class="btn btn-primary btn-sm m-r-xs"
          (click)="importFromXml()"
        >
          <i class="fa fa-file-code-o"></i> Import from XML
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm m-r-xs"
          (click)="importField()"
          [disabled]="!hasLpgaTournamentId()"
          [title]="
            hasLpgaTournamentId()
              ? 'Import the latest field and rankings from LPGA HQ'
              : 'Import from HQ is unavailable until this tournament has an LPGA Tournament ID.'
          "
        >
          <i class="fa fa-cloud-download"></i> Import from HQ
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm m-r-xs"
          (click)="openPlayerModal()"
        >
          <i class="fa fa-user-plus"></i> Add Player
        </button>
        }
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="printFieldList()"
          [disabled]="!canPrintFieldList()"
          [title]="
            canPrintFieldList()
              ? 'Download the latest tournament field list'
              : 'Printing is unavailable until tournament details are loaded'
          "
        >
          @if (isPrintingFieldList()) {
          <i class="fa fa-spinner fa-spin"></i>
          } @else {
          <i class="fa fa-print"></i>
          }
          <span class="m-l-xs">Print Field List</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Transfer Controls Column -->
  <div class="col-lg-1">
    <div class="transfer-controls-container">
      <button
        type="button"
        class="btn btn-primary btn-sm m-b-sm transfer-control-btn"
        (click)="addPlayerToField()"
        [disabled]="!canAddToField()"
        [title]="
          canAddToField()
            ? 'Add selected alternate to field'
            : 'Select an alternate player first'
        "
      >
        <i class="fa fa-arrow-left"></i> Add
      </button>
      <button
        type="button"
        class="btn btn-warning btn-sm m-b-sm transfer-control-btn"
        (click)="swapPlayers()"
        [disabled]="!canSwap()"
        [title]="
          canSwap()
            ? 'Swap selected field player with selected alternate'
            : 'Select both a field player and an alternate'
        "
      >
        <i class="fa fa-arrow-left"></i> Swap <i class="fa fa-arrow-right"></i>
      </button>
      <button
        type="button"
        class="btn btn-danger btn-sm m-b-lg transfer-control-btn"
        (click)="removePlayerFromField()"
        [disabled]="!canRemoveFromField()"
        [title]="
          canRemoveFromField()
            ? 'Move selected field player to alternates'
            : 'Select a field player first'
        "
      >
        Remove <i class="fa fa-arrow-right"></i>
      </button>
    </div>
  </div>

  <!-- Right Column: Alternates -->
  <div class="col-lg-5">
    <!-- Alternates List -->
    <div class="ibox alternates-section">
      <div class="ibox-title">
        <h5><i class="fa fa-list-ol"></i> Alternates</h5>
      </div>
      <div class="ibox-content">
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th width="30">#</th>
                <th width="50">
                  <app-sortable-header
                    [column]="'fieldRank'"
                    [sortConfig]="alternatesSortConfig()"
                    (sort)="onAlternatesSort($event)"
                  >
                    Rank
                  </app-sortable-header>
                </th>
                <th width="80">
                  <app-sortable-header
                    [column]="'categoryName'"
                    [sortConfig]="alternatesSortConfig()"
                    (sort)="onAlternatesSort($event)"
                  >
                    Cat
                  </app-sortable-header>
                </th>
                <th>
                  <app-sortable-header
                    [column]="'playerLastName'"
                    [sortConfig]="alternatesSortConfig()"
                    (sort)="onAlternatesSort($event)"
                  >
                    Name
                  </app-sortable-header>
                </th>
                <th width="20">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (alternate of alternatePlayers(); track $index) {
              <tr
                (click)="selectAlternatePlayer(alternate.player.playerId!)"
                (dblclick)="editAlternate(alternate)"
                style="cursor: pointer"
                [class.table-info]="
                  isAlternatePlayerSelected(alternate.player.playerId!)
                "
              >
                <td>{{ alternate.number }}</td>
                <td>{{ alternate.rank }}</td>
                <td>
                  <span class="label label-default">{{
                    alternate.category
                  }}</span>
                </td>
                <td>
                  <strong>{{ alternate.name }}</strong>
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-white btn-xs"
                    (click)="editAlternate(alternate)"
                    title="Edit Player"
                  >
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-white btn-xs"
                    (click)="deleteAlternateFromTournament(alternate.player)"
                    title="Delete Player"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
              } @if (alternatePlayers().length === 0) {
              <tr>
                <td colspan="5" class="text-center text-muted">
                  <em>No alternates</em>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <app-table-pagination
          [paginationData]="alternatesPaginationResult()"
          (pageChange)="onAlternatesPageChange($event)"
        >
        </app-table-pagination>
      </div>
      <div class="ibox-footer text-right">
        <button
          type="button"
          class="btn btn-primary btn-sm"
          (click)="printAlternates()"
          [disabled]="!canPrintAlternates()"
          [title]="
            canPrintAlternates()
              ? 'Download the alternates list'
              : 'Printing is unavailable until tournament details are loaded'
          "
        >
          @if (isPrintingAlternates()) {
          <i class="fa fa-spinner fa-spin"></i>
          } @else {
          <i class="fa fa-print"></i>
          }
          <span class="m-l-xs">Print Alternates</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Import Modal -->
<app-import-modal
  [showCoursesOption]="false"
  (importConfirmed)="onImportConfirmed($event)"
></app-import-modal>

<!-- XML Import Modal -->
<app-xml-import-modal
  (importConfirmed)="onXmlImportConfirmed($event)"
></app-xml-import-modal>

<!-- Player Add/Edit Modal -->
<!-- Player Add/Edit Modal -->
<app-player-modal
  [existingPlayerIds]="existingPlayerIds()"
  (playerSaved)="onPlayerSaved($event)"
>
</app-player-modal>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  (confirmed)="onDeletePlayerConfirmed($event)"
></app-confirmation-dialog>

<!-- Field Parameters Modal -->
<app-field-parameters-modal
  (fieldParametersSaved)="onFieldParametersSaved($event)"
></app-field-parameters-modal>
